import React, { Component } from "react";
import { addProduct, removeProduct } from "../../../../../services/cart/actions";

import CustomizationV3 from "../../CustomizationV3";
import { updateCart } from "../../../../../services/total/actions";
import Fade from "react-reveal/Fade";
import Ink from "react-ink";
import LazyLoad from "react-lazyload";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getAssetUrl } from "../../../../helpers/getAssetUrl";

import ProgressiveImage from "react-progressive-image";
import RecommendedItemsV2 from "../RecommendedItemsV2";

class RecommendedItems extends Component {
	// static contextTypes = {
	// 	router: () => null,
	// };

	forceStateUpdate = () => {
		setTimeout(() => {
			this.forceUpdate();
			this.props.update();
		}, 100);
	};

	addProductToCart = (product) => {
		console.log('🛒 RecommendedItems: Adding product to cart', product);
		const { addProduct } = this.props;
		addProduct(product);
		this.forceStateUpdate();
	};

	componentDidUpdate(prevProps) {
		if (prevProps.cartProducts.length !== this.props.cartProducts.length) {
		  this.forceUpdate();
		}
	}

	render() {
		const { addProduct, removeProduct, cartProducts, restaurant } = this.props;
		// Don't mutate the original product - create a copy with quantity
		const product = Object.assign({}, this.props.product, { quantity: 1 });
		
		const isItemExistInCart = (item_id) => {
            let cc = cartProducts.find(cartItem => {
                return cartItem.id === item_id
            });
            if(cc !== undefined) {
                return true;
            }
            return false;
        }
		return (
			<React.Fragment>
				{localStorage.getItem("recommendedLayoutV2") === "true" ? (
					 <RecommendedItemsV2
						product={product}
						restaurant={restaurant}
						cartProducts={cartProducts}
						addProduct={addProduct}
						removeProduct={removeProduct}
						updateCart={this.props.updateCart}
						update={this.props.update}
						/>
				) : (
					<div key={product.id}
						className="category-list-item"
						style={{
							display: "flex",
							justifyContent: "space-between",
						}}
					>
						<div className={`${product.image !== null && product.addons && Object.keys(product.addons).length > 0 && "customized-item-list-img"} ${product.image === null && product.addons && Object.keys(product.addons).length > 0 && "blank-image-no-desc"} list-item-img-sec`}>
						<React.Fragment>
						{product.image !== null ? (
							<React.Fragment>
								<Link to={restaurant.slug + "/" + product.id}>
									<React.Fragment>
										<ProgressiveImage
											src={getAssetUrl(product.image)}
											placeholder="/assets/img/various/blank.png"
										>
											{(src, loading) => (
												<img
													style={product.image === null ? {
														opacity: loading ? "0.5" : "1",
														width: "120px",
														height: "10px",
													} : {
														opacity: loading ? "0.5" : "1",
													}}
													src={getAssetUrl(src)}
													alt={product.name}
													className="flex-item-image"
												/>
											)}
										</ProgressiveImage>
									</React.Fragment>
								</Link>
							</React.Fragment>
						):(
							<React.Fragment>
								<Link to={restaurant.slug + "/" + product.id} onClick={e => e.preventDefault()}>
									<React.Fragment>
										<ProgressiveImage
											src={getAssetUrl(product.image)}
											placeholder="/assets/img/various/blank.png"
										>
											{(src, loading) => (
												<img
													style={product.image === null ? {
														opacity: loading ? "0.5" : "1",
														width: "120px",
													} : {
														opacity: loading ? "0.5" : "1",
													}}
													src={getAssetUrl(src)}
													alt={product.name}
													className="flex-item-image"
												/>
											)}
										</ProgressiveImage>
									</React.Fragment>
								</Link>
							</React.Fragment>
						)}
						</React.Fragment>
						</div>
						<div className="list-items-new">
							{localStorage.getItem("showVegNonVegBadge") === "true" &&
							product.is_veg !== null && (
								<React.Fragment>
									{product.is_veg ? (
										<img
											src="/assets/img/various/veg-icon-bg.png"
											alt="Veg"
											className="mr-1 veg-non-veg-badge"
										/>
									) : (
										<img
											src="/assets/img/various/non-veg-icon-bg.png"
											alt="Non-Veg"
											className="mr-1 veg-non-veg-badge"
										/>
									)}
								</React.Fragment>
							)}
						<div
							className={
								product.image !== null ? "flex-item-name" : "flex-item-name"
							}
						>
							<span className="item-name">{product.name}</span>{" "}
							<span className="item-badge-collection"></span>
							<span className="item-price">
								{localStorage.getItem("hidePriceWhenZero") === "true" &&
								product.price === "0.00" ? null : (
									<React.Fragment>
										{product.old_price > 0 && (
											<span className="strike-text mr-1">
												{" "}
												{localStorage.getItem("currencySymbolAlign") ===
													"left" &&
													localStorage.getItem("currencyFormat")}{" "}
												{product.old_price}
												{localStorage.getItem("currencySymbolAlign") ===
													"right" &&
													localStorage.getItem("currencyFormat")}
											</span>
										)}

										<span>
											{localStorage.getItem("currencySymbolAlign") ===
												"left" &&
												localStorage.getItem("currencyFormat")}{" "}
											{product.price}
											{localStorage.getItem("currencySymbolAlign") ===
												"right" &&
												localStorage.getItem("currencyFormat")}
										</span>

										{product.old_price > 0 &&
										localStorage.getItem("showPercentageDiscount") ===
											"true" ? (
											<React.Fragment>
												<p
													className="price-percentage-discount mb-0"
													style={{
														color: localStorage.getItem(
															"cartColorBg"
														),
													}}
												>
													{parseFloat(
														((parseFloat(product.old_price) -
															parseFloat(product.price)) /
															parseFloat(product.old_price)) *
															100
													).toFixed(0)}
													{localStorage.getItem(
														"itemPercentageDiscountText"
													)}
												</p>
											</React.Fragment>
										) : (
											<br />
										)}
									</React.Fragment>
								)}
							</span>
						</div>
						</div>

						<div className={`item-actions pull-right pb-0 ${localStorage.getItem("showVegNonVegBadge") === "true" && product.is_veg !== null && product.image === null ? "mt-15" : null}`} style={product.image === null ? {top:"5px"} : null}>
							<div
								className="btn-group btn-group-sm"
								role="group"
								aria-label="btnGroupIcons1"
								style={{ height: "32px"}}
							>
								{product.is_active ? (
									<React.Fragment>
										{/* Items WITH addons - Always use CustomizationV3 */}
										{product.addons && Object.keys(product.addons).length ? (
											<CustomizationV3
												product={product}
												addProduct={this.addProductToCart}
												cartProducts={cartProducts}
												forceUpdate={this.forceStateUpdate}
												updateCart={this.props.updateCart}
											/>
										) : (
											/* Items WITHOUT addons - Show regular controls */
											<React.Fragment>
											{isItemExistInCart(product.id) ? (
												<React.Fragment>
												<button
													type="button"
													className="btn btn-add-remove btn-list-item-m"
													style={{
														color: localStorage.getItem("cartColor-bg"),
													}}
													onClick={() => {
														product.quantity = 1;
														removeProduct(product);
														this.forceStateUpdate();
													}}
												>
													<span className="btn-dec"></span>
													<Ink duration="500" />
												</button>
												<button type="button" className="btn btn-quantity btn-list-item-q">
													{cartProducts.find(
														(cp) =>
															cp.id ===
															product.id
													).quantity}
												</button>
												<button
													type="button"
													className="btn btn-add-remove btn-list-item-p"
													style={{
														color: localStorage.getItem("cartColor-bg"),
													}}
													onClick={() => {
														addProduct(product);
														this.forceStateUpdate();
													}}
												>
													<span className="btn-inc">+</span>
													<Ink duration="500" />
												</button>
												</React.Fragment>
											) : (
												<button
													type="button"
													className="btn btn-add-remove btn-custom-add btn-list-item-add"
													style={{
														color: localStorage.getItem("cartColor-bg"),
													}}
													onClick={() => {
														product.quantity = 1;
														addProduct(product);
														this.forceStateUpdate();
													}}
												>
													Add
												</button>
											)}
											</React.Fragment>
										)}
									</React.Fragment>
									
								) : (
									<div className="u3m9n">
										<span className="itemNotAvail"> {localStorage.getItem("cartItemNotAvailable")}</span>
									</div>
								)}
							</div>
							{product.addons && Object.keys(product.addons).length > 0 && (
								<React.Fragment>
									<span
										className="customizable-item-text d-block text-center"
									>
										{localStorage.getItem("customizableItemText")}
									</span>
									<br />
								</React.Fragment>
							)}
						</div>
					</div>
				)}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	cartProducts: state.cart.products,
});

export default connect(
	mapStateToProps,
	{ addProduct, removeProduct, updateCart }
)(RecommendedItems);
